import { createFileRoute, Link } from "@tanstack/react-router";
import { abs } from "@/lib/site";
import { SiteHeader, SiteFooter } from "@/components/SiteChrome";
import { categories } from "@/data/symbols";

export const Route = createFileRoute("/categories/")({
  head: () => ({
    meta: [
      { title: "All symbol categories — hearts, stars, arrows, math and more" },
      {
        name: "description",
        content:
          "Browse every symbol category on CoolSymbols.cool — hearts, stars, arrows, math, currency, zodiac, chess, music, weather, tech and more.",
      },
      { property: "og:title", content: "All symbol categories" },
      {
        property: "og:description",
        content: "Every symbol category, all in one place.",
      },
      { property: "og:url", content: abs("/categories") },
    ],
    links: [{ rel: "canonical", href: abs("/categories") }],
  }),
  component: AllCategories,
});

function AllCategories() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-12 sm:px-6 sm:py-16">
        <h1 className="font-display text-4xl font-bold sm:text-5xl">
          All <span className="text-gradient">categories</span>
        </h1>
        <p className="mt-3 max-w-2xl text-muted-foreground">
          Every symbol set on CoolSymbols.cool. Pick a category to see all symbols
          inside and copy with one click.
        </p>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to="/categories/$slug"
              params={{ slug: c.slug }}
              className="group glass rounded-2xl p-5 transition-all hover:-translate-y-0.5 hover:shadow-[var(--shadow-glow)]"
            >
              <div className="flex items-center gap-3">
                <span className="text-3xl text-gradient">{c.emoji}</span>
                <span className="flex-1">
                  <span className="block font-display text-lg font-semibold">
                    {c.name}
                  </span>
                  <span className="block text-sm text-muted-foreground">
                    {c.symbols.length} symbols
                  </span>
                </span>
                <span className="text-muted-foreground group-hover:text-foreground">
                  →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
